// utils/AxiosRequestManager.ts
interface ControllerItem {
    controller: AbortController;
    allowMultiple: boolean;
}

class RequestManager {
    private controllers: Map<string, ControllerItem[]> = new Map();

    addController(key: string, controller: AbortController, allowMultiple: boolean) {
        if (!this.controllers.has(key)) {
            this.controllers.set(key, []);
        }
        this.controllers.get(key)!.push({ controller, allowMultiple });
      
    }

    getControllers(key: string): AbortController[] | null {
        const items = this.controllers.get(key);
        return items ? items.map(item => item.controller) : null;
    }

    removeController(key: string) {
        this.controllers.delete(key);
    }

    cancelAll() {
        
        this.controllers.forEach((items, key) => {
            items.forEach(({ controller, allowMultiple }) => {
                if (!allowMultiple) {
                    controller.abort();
                } else {
                    console.log(``);
                }
            });
        });

        // Clean up cancelled requests
        const keysToDelete: string[] = [];
        this.controllers.forEach((items, key) => {
            const remaining = items.filter(item => item.allowMultiple);
            if (remaining.length === 0) {
                keysToDelete.push(key);
            } else {
                this.controllers.set(key, remaining);
            }
        });
        
        keysToDelete.forEach(key => this.controllers.delete(key));
    }

    cancelAllForce() {
        this.controllers.forEach((items) => {
            items.forEach(({ controller }) => {
                controller.abort();
            });
        });
        this.controllers.clear();
    }
}

export const AxiosRequestManager = new RequestManager();


// utils/axiosRequestManager.ts
// export class AxiosRequestManager {
//   private static controllerMap: Map<string, AbortController[]> = new Map();

//   static addController(key: string, controller: AbortController, allowMultiple = false) {
//     if (allowMultiple) {
//       // Keep multiple controllers
//       const existing = this.controllerMap.get(key) || [];
//       existing.push(controller);
//       this.controllerMap.set(key, existing);
//     } else {
//       // Cancel and replace previous
//       this.cancelControllers(key);
//       this.controllerMap.set(key, [controller]);
//     }
//   }

//   static removeController(key: string, controller?: AbortController) {
//     if (!this.controllerMap.has(key)) return;

//     if (controller) {
//       // remove only the specific one
//       const arr = this.controllerMap.get(key)!.filter(c => c !== controller);
//       if (arr.length) {
//         this.controllerMap.set(key, arr);
//       } else {
//         this.controllerMap.delete(key);
//       }
//     } else {
//       this.controllerMap.delete(key);
//     }
//   }

//   static getControllers(key: string): AbortController[] | undefined {
//     return this.controllerMap.get(key);
//   }

//   static cancelControllers(key: string) {
//     const controllers = this.controllerMap.get(key);
//     if (controllers) {
//       controllers.forEach(c => c.abort());
//       this.controllerMap.delete(key);
//     }
//   }

//   static cancelAll() {
//     this.controllerMap.forEach(arr => arr.forEach(c => c.abort()));
//     this.controllerMap.clear();
//   }
// }
